export default {
  endUseSortsLoading: false,
  endUseSorts: []
}
